module.exports = __webpack_public_path__ + "media/images/selo-transparent-e64755a3ce016e0ca46bf03c234ed0b8.png";